module.exports = __webpack_public_path__ + "static/channels-1-428316808cd2e9f57367fce57ca211ab.svg";